exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#create-profile-container{border:1px solid #e4ac02;padding:1rem;overflow-y:auto;overflow-x:hidden;height:95%;-webkit-border-radius:.3rem;-moz-border-radius:.3rem;border-radius:.3rem;max-width:55%}#page-container{height:100%;background-color:#000}@media(min-width: 300px){#create-profile-container{max-width:90%}}@media(max-width: 767px){#create-profile-container{max-width:100%;width:100%;height:auto;overflow:visible;margin-left:0;margin-right:0}#create-profile-container .img-upload-form-col{flex:0 0 100%;max-width:100%;margin-bottom:1rem}#create-profile-container .form-row>.col-7{flex:0 0 100%;max-width:100%}}@media(min-width: 900px){#create-profile-container{width:90%;max-width:90%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/pages/CreateProfile/styles.scss
// module id = 865
// module chunks = 0